export default {
  button: {
    login: "Log in",
    logout: "Log out",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    next: "Next",
    doorlock_uninstall: "Uninstall",
    battery: "Battery",
    room_add: "Room Add",
    floor_add: "Floor Add",
    building_add: "Building Add",
    staff_add: "Staff Add",
    key_issue: "Key Issue",
    booking_excel_upload: "Booking Upload",
    booking_excel_download: "Booking Download",
    booking_add: "Booking Add",
    sms_resend: "SMS Resend",
    report_excel_download: "Report Download",
    close: "Close",
    ok: "OK",
  },
  placeholder: {
    phone_number: "Numbers only",
    password: "Password",
    hotel_name: "Enter property name.",
    address: "Enter address.",
    description_hotel: "Enter memo.",
    commonroom_name: "Enter common door name.",
    commonroom_select: "Select common door.",
    start_at: "Select start date.",
    end_at: "Select end date.",
    type: "Type",
    type_select: "Select type.",
    building: "Building",
    building_name: "Enter building name.",
    building_select: "Select building.",
    room_name: "Enter room name.",
    room_select: "Select room.",
    floor_name: "Enter floor name.",
    floor_select: "Select floor.",
    rms_id: "Enter RMS ID.",
    advertise_strength: "Select advertise strength.",
    connected_strength: "Select connected strength.",
    staff_name: "Enter staff name.",
    role: "Select staff level.",
    checkin_at: "Select check-in date and time.",
    checkout_at: "Select check-out date and time.",
    user_name: "Enter guest name.",
    description_booking: "Enter memo.",
    file_select: "Excel file only.",
  },
  description: {
    building_count: "Buildings",
    room_count: "Rooms",
    app_link: "App link",
    no_room_type: "No room type.",
  },
  success_message: {
    edit_hotel: "Property edited.",
    delete_hotel: "Property deleted.",
    delete_booking: "Booking cancelled.",
    add_booking: "Booking added.",
    issue_key: "Key issued.",
    delete_key: "Key deleted.",
    add_building: "Building added.",
    delete_building: "Building deleted.",
    edit_building: "Building edited.",
    add_floor: "Floor added.",
    delete_floor: "Floor deleted.",
    edit_floor: "Floor edited.",
    add_room: "Room added.",
    delete_room: "Room deleted.",
    edit_room: "Room edited.",
    uninstall_doorlock: "Lock uninstalled.",
    add_staff: "Staff added.",
    delete_staff: "Staff deleted.",
    edit_staff: "Staff edited.",
    delete_staffkey: "Staff key deleted.",
    send_sms: "SMS sent.",
    upload_file: "File uploaded.",
  },
  error_message: {
    login: "Log in failed.",
    edit_hotel: "Property edit failed.",
    delete_hotel: "Property delete failed.",
    delete_booking: "Booking delete failed.",
    add_booking: "Booking add failed.",
    missing_parameter: "Please check the required fields.",
    issue_key: "Key issue failed.",
    delete_key: "Key delete failed.",
    add_building: "Building add failed.",
    delete_building: "Building delete failed.",
    edit_building: "Building edit failed.",
    add_floor: "Floor add failed.",
    delete_floor: "Floor delete failed.",
    edit_floor: "Floor edit failed.",
    add_room: "Room add failed.",
    delete_room: "Room delete failed.",
    edit_room: "Room edit failed.",
    uninstall_doorlock: "Lock uninstall failed.",
    add_staff: "Staff add failed.",
    delete_staff: "Staff delete failed.",
    edit_staff: "Staff edit failed.",
    issue_staffkey: "Staff key issue failed.",
    delete_staffkey: "Staff key delete failed.",
    send_sms: "SMS failed.",
    no_file: "Please select the excel file to upload.",
    upload_file: "File upload failed.",
    download_file: "File download failed.",
    no_data: "No data",
  },
  confirm_message: {
    delete_hotel: "Do you want to delete this property?",
    delete_booking: "Do you want to delete this booking?",
    download_booking: "Do you want to download booking list?",
    delete_key: "Do you want to delete this key?",
    delete_building: "Do you want to delete this building?",
    delete_floor: "Do you want to delete this floor?",
    delete_room: "Do you want to delete this room?",
    uninstall_doorlock: "Do you want to uninstall this lock?",
    delete_staff: "Do you want to delete this staff?",
    delete_staffkey: "Do you want to delete this staff key?",
    send_sms: "Do you want to send the SMS?",
  },
  content_title: {
    hotel_list: "Select property.",
    hotel_detail: "Property detail",
    building_list: "Building list",
    building_detail: "Building detail",
    building_add: "Building add",
    building_edit: "Building edit",
    floor_list: "Floor list",
    floor_detail: "Floor detail",
    floor_add: "Floor add",
    floor_edit: "Floor edit",
    room_list: "Room list",
    room_detail: "Room detail",
    room_add: "Room add",
    room_edit: "Room edit",
    doorlock_list: "Door lock list",
    doorlock_detail: "Door lock detail",
    battery_chart: "Battery chart",
    staff_list: "Staff list",
    staff_detail: "Staff detail",
    staff_add: "Staff add",
    staff_edit: "Staff edit",
    staffkey_issue: "Staff key issue",
    booking_list: "Booking list",
    booking_detail: "Booking detail",
    booking_add: "Booking add",
    booking_edit: "Booking edit",
    booking_upload: "Booking upload",
    key_issue: "Key Issue",
    report: "Report",
    report_detail: "Report detail",
  },
  sidebar_column: {
    home: "Home",
    hotel: "Property",
    building: "Building",
    floor: "Floor",
    room: "Room",
    doorlock: "Door lock",
    doorlockTile: "Door lock (tile type)",
    booking: "Booking",
    staff: "Staff",
    report: "Report",
  },
  tab_column: {
    building_detail: "Building info",
    floor_list: "Floor list",
    floor_detail: "Floor info",
    room_list: "Room list",
    room_detail: "Room info",
    doorlock_detail: "Door lock info",
    battery_chart: "Battery status",
    doorlock_log: "Door lock log",
    staff_detail: "Staff info",
    staffkey_list: "Staff key list",
    booking_detail: "Booking info",
    userkey_list: "Key list",
  },
  data_column: {
    hotel_name: "Property name",
    timezone: "Time zone",
    address: "Address",
    description: "Memo",
    pincode_day_type_offset: "PIN Code check in time_Day type",
    commonroom_name: "Common door",
    view: "View",
    doorlock_name: "Room",
    type: "Type",
    doorlock_serial: "Serial",
    building: "Building",
    building_name: "Building",
    floor: "Floor",
    floor_name: "Floor",
    status: "Status",
    fw_type: "Model",
    fw_version: "FW version",
    battery_status: "Battery",
    created_at: "Created at",
    updated_at: "Updated at",
    log_id: "Log id",
    message: "Message",
    evented_at: "Date",
    room: "Room",
    room_name: "Room",
    rms_id: "RMS ID",
    allow_keytag: "Key tag",
    advertise_strength: "Advertise strength",
    connected_strength: "Connected strength",
    room_count: "Room",
    commonroom_count: "Common door",
    staff: "Staff",
    staff_name: "Staff name",
    role: "Level",
    regist_status: "Status",
    phone_number: "Phone number",
    cardkey_count: "Issued Card key",
    mobilekey_count: "Issued Mobile key",
    pincode_count: "Issued PIN Code",
    issue_type: "Issue type",
    start_at: "Start",
    end_at: "End",
    grantor: "Issued by",
    key_type: "Key type",
    card_no: "Card #",
    exchangekey: "Mobile key code",
    pincode: "PIN Code",
    sequence: "Sequence",
    user_name: "Guest name",
    checkin_at: "Check-in",
    checkout_at: "Check-out",
    pincode_type: "PIN Code type",
    key_user_name: "Guest name",
    content: "Detail",
    checkin_day: "Check-in date",
    checkin_hour: "Check-in time",
    checkout_day: "Check-out date",
    checkout_hour: "Check-out time",
    facility: "Facility",
    actor_name: "User",
    actor_phone_number: "Phone number",
    actor_role: "Staff level",
    owner_name: "Name",
    owner_phone_number: "Phone number",
    owner_role: "Staff level",
    content_detail: "Detail",
    file_select: "File",
  },
  data: {
    staff_role: {
      master: "Master",
      manager: "Staff",
      housekeeping: "Housekeeping",
      manager_mobilekey: "Staff mobile key",
      doorlock_setting: "Door lock setting",
    },
    doorlock_type: {
      room: "Room",
      commonroom: "Common door",
      building: "Building door",
      floor: "Floor door",
      elevator: "Elevator",
      keytag: "Key tag",
    },
    doorlock_status: {
      created: "Not installed",
      installed: "Installed",
    },
    allow_keytag: {
      true: "O",
      false: "X",
    },
    regist_status: {
      granting: "Waiting for sign up",
      granted: "Signed up",
    },
    issue_type: {
      copy: "Copy",
      new: "New",
    },
    key_type: {
      cardkey: "Card key",
      mobilekey: "Mobile key",
      pincode: "PIN Code",
    },
    pincode_type: {
      day: "Day",
      hour: "Hour",
      min: "10mins",
    },
    report_type: {
      key_issue: "Key issue Report",
      facility: "Facility Report",
      staff: "Staff Report",
      use_mobilekey: "Mobile key use Report",
    },
    report_key_type: {
      mobilekey: "Mobile key",
      pincode: "PIN Code",
      cardkey: "Card key",
      cardkey_master: "Master card",
      cardkey_ble: "Setting card",
      cardkey_init: "Reset card",
    },
    report_content: {
      issue_userkey: "Issue guest key",
      cancel_userkey: "Cancel guest key",
      create_hotel: "Create property",
      update_hotel: "Update property info",
      delete_hotel: "Delete property",
      create_building: "Create building",
      update_building: "Update building info",
      delete_building: "Delete building",
      create_room: "Create room",
      update_room: "Update room info",
      delete_room: "Delete room",
      create_commonroom: "Create common door",
      update_commonroom: "Update common door info",
      delete_commonroom: "Delete common door",
      install_doorlock: "Install door lock",
      uninstall_doorlock: "Uninstall door lock",
      grant_staff: "Add staff",
      update_staff: "Update staff info",
      revoke_staff: "Delete staff",
      issue_staffkey: "Issue staff key",
      cancel_staffkey: "Cancel staff key",
      start_cleaning: "Start cleaning",
      end_cleaning: "End cleaning",
      open_staffmobilekey: "Open by staff mobile key",
      open_usermobilekey: "Open by guest mobile key",
    },
  },
  doorlock_detail_modal: {
    room: "Room",
    room_condition: "Room condition",
    check_in_out: "Check-in/Check-out",
    card_key_issuance_information: "Card key issuance information",
    pin_code_issuance_information: "Pin code issuance information",
    mobile_key_issuance_information: "Mobile key issuance information",
    lora_network_information: "LoRa module status information",
    door_open: "Door Open",
    set_door_lock_time: "Set door lock time",
    change_door_lock_sequence_number: "Lockout (card key)",
    move_room_card_key: "Move room (card key)",
    extension_of_check_out_time: "Extension of check-out time",
    change_room_status: "Change room status",
    move_room_pin_code: "Move room (pin code)",
    status_logd: "Status Logs",
    control_logd: "Control Logs",
    full_sync: "Full sync",
    function: "Function",
    check_out: "Check-out",
    change_check_out_time: "Change Checkout Time",
    last_update_time: "Last Update Time",
    lock_out_pin_code: "Lockout (Pincord)",
  },
  company_title: "H2O SMW",
};
